import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { TopBar } from "./TopBar";
import { ClaimHeader } from "./ClaimHeader";
import { Sidebar } from "./Sidebar";

export function AppShell({ children }: { children: ReactNode }) {
  const location = useLocation();
  const isVoltaire = location.pathname.startsWith("/voltaire");

  return (
    <div className="app-shell">
      <TopBar />
      <ClaimHeader showActions={!isVoltaire} />
      <div className="layout">
        <Sidebar />
        <div className="main">{children}</div>
      </div>
    </div>
  );
}
